@if (task) {
    <unclaimed-message [task]="task" (claimed)="getTask()"></unclaimed-message>
}
@if (task?.purchaseRequisition) {
    <purchase-requisition-detail
        [purchaseRequisition]="task.purchaseRequisition"
        [supplierRequired]="true"
        [supplierChangeAllowed]="task.supplierChangeAllowed"
        [editingWithDialog]="true"
        [validUntilRequired]="true"
        [task]="task"
        (validationStatusChanged)="purchaseRequisitionValidationChange($event)"
        (currencyAcceptanceChanged)="onCurrencyAcceptanceChanged($event)"
        #purchaseRequisitionDetailComponent
    >
        <ng-container *removeIfUnclaimed="task">
            <div class="row justify-content-end mb-2">
                <div class="col-auto">
                    <task-hint-display [hint]="task.hint"></task-hint-display>
                </div>
            </div>
            @if (!resultValid) {
                <div class="row justify-content-end mb-3">
                    <div class="col-auto">
                        @if (!rfqResultSelected) {
                            <div class="alert alert-danger mb-0">
                                {{ 'Für dieses Resultat muss genau ein Lieferant ausgewählt sein!' | translate }}
                            </div>
                        }
                    </div>
                </div>
            }
            <!-- EPROC-11425 reopen #5b (238308): !purchaseRequisitionValid was the only blocking branch
                 of approvalBlocked without any hint — the approver saw a dead release button and nothing
                 else. Generic on purpose: the concrete reason (missing field, pending currency check) is
                 shown at its place inside the embedded demand. A currency conflict also invalidates the
                 purchase requisition, but already has the red blocker above — no second banner then. -->
            @if (!purchaseRequisitionValid && !currencyBlocksOrder && !isCompleted) {
                <div class="row justify-content-end mb-3">
                    <div class="col-auto">
                        <div class="alert alert-warning mb-0" data-cy="PURCHASE_REQUISITION_INVALID_HINT">
                            <em class="fas fa-circle-info pe-1"></em>
                            {{
                                'Die Freigabe ist noch nicht möglich: Die Bedarfsmeldung erfüllt noch nicht alle Voraussetzungen. Prüfen Sie die Hinweise und Pflichtfelder in der Bedarfsmeldung.'
                                    | translate
                            }}
                        </div>
                    </div>
                </div>
            }
            @if (currencyBlocksOrder) {
                <div class="row justify-content-end mb-3">
                    <div class="col-auto">
                        <div class="alert alert-danger mb-0">
                            <em class="fas fa-triangle-exclamation pe-1"></em>
                            <!-- demandCurrency is null once the positions use more than one currency. -->
                            @if (noSelectableCurrencies) {
                                <!-- Empty customer-supplier intersection: deliberate dead end (EPROC-11425,
                                     decision 06.08.2026) — name the way out instead of an empty list. -->
                                {{
                                    'Freigabe als Bestellung nicht möglich: Der Mandant und die gewählten Lieferanten haben keine gemeinsame Währung. Wählen Sie andere Lieferanten oder lassen Sie die Währungs-Stammdaten erweitern.'
                                        | translate
                                }}
                            } @else if (currencyAcceptance?.demandCurrency && customerRejectsDemandCurrency) {
                                <!-- Name the actual party: this rejection is the customer's own master data,
                                     it exists even without any supplier (EPROC-11425 reopen #2). -->
                                {{
                                    'Freigabe als Bestellung nicht möglich: Die Währung \{\{currency\}\} ist vom Mandanten nicht zugelassen. Wählbare Währungen: \{\{selectable\}\}'
                                        | translate
                                            : {
                                                  currency: currencyAcceptance?.demandCurrency,
                                                  selectable: selectableCurrencyList,
                                              }
                                }}
                            } @else if (currencyAcceptance?.demandCurrency) {
                                {{
                                    'Freigabe als Bestellung nicht möglich: Die Währung \{\{currency\}\} wird nicht von allen gewählten Lieferanten akzeptiert. Wählbare Währungen: \{\{selectable\}\}'
                                        | translate
                                            : {
                                                  currency: currencyAcceptance?.demandCurrency,
                                                  selectable: selectableCurrencyList,
                                              }
                                }}
                            } @else {
                                {{
                                    'Freigabe als Bestellung nicht möglich: Die Währungen des Belegs werden nicht von allen gewählten Lieferanten akzeptiert. Wählbare Währungen: \{\{selectable\}\}'
                                        | translate: { selectable: selectableCurrencyList }
                                }}
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="row justify-content-end">
                <div class="col-auto">
                    @if (selectedResultCtrl) {
                        <div>
                            <iim-advanced-autocomplete
                                [formControl]="selectedResultCtrl"
                                [deletable]="false"
                                [showLabel]="true"
                                [label]="'Resultat der Bedarfsmeldung' | translate"
                                [required]="true"
                            >
                                @for (result of task.possibleResults; track result) {
                                    <iim-autocomplete-option [value]="result">
                                        {{ result.valueDisplay | translate }}
                                    </iim-autocomplete-option>
                                }
                            </iim-advanced-autocomplete>
                        </div>
                    }
                    <div class="btn-group w-100 my-2">
                        <button class="btn btn-secondary" (click)="sendToRework()" data-cy="REWORK">
                            <em class="fas fa-rotate-left pe-2"></em>
                            {{ 'Überarbeitung veranlassen' | translate }}
                        </button>
                        <button class="btn btn-warning" (click)="decline()">
                            <em class="fas fa-ban pe-2"></em>
                            {{ 'ablehnen' | translate }}
                        </button>
                        <button class="btn btn-success" [disabled]="approvalBlocked" (click)="approve()">
                            <em class="fas fa-check pe-2"></em>
                            {{ 'freigeben' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="row justify-content-end mb-2" *showIfUnclaimed="task">
            <div class="col-auto">
                <claim-btn [task]="task" (claimed)="getTask()"></claim-btn>
            </div>
        </div>
    </purchase-requisition-detail>
}
